// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseQueryResult } from '@tanstack/react-query';
import { InstructedCollateral } from '@daml.js/utility-collateral-app-v1/lib/Utility/Collateral/App/Model/Collateral';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import TemplateContract from '../../../../utils/TemplateContract';
import { useQueryWithOptions } from '../../../other/useQueryWithOptions';
import { useOperatorParty } from '../../utility-operator/useOperatorParty';

const useInstructedCollateral: () => UseQueryResult<
  TemplateContract<InstructedCollateral>[],
  string
> = () => {
  const ledgerApi = useLedgerApiClient();
  const operator = useOperatorParty()?.data || '';
  return useQueryWithOptions({
    queryKey: ['queryInstructedCollateral', operator],
    queryFn: async (_, options) => {
      return ledgerApi.queryInstructedCollateral(options, operator);
    },
  });
};

export default useInstructedCollateral;
